module.exports = __webpack_public_path__ + "activity6.97e835cf.png";